export enum UploadStatus {
    UPLOADING = 'UPLOADING',
    SUCCESSFUL = 'SUCCESSFUL',
    FAILED = 'FAILED',
    INVALID = 'INVALID',
    PREEXISTING = 'PREEXISTING',
}
